<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCol xs="6" lg="6" style="margin-top: 20px">
        <select v-model="gameName" class="form-control sl">
          <option v-for="game in gameList" v-bind:key="game.id">
            {{ game.name }}
          </option>
        </select>
      </CCol>
      <CCol xs="12" lg="12" style="margin-top: 20px">
        <CTabs variant="pills">
          <CTab :title="gameName + ' claimed Points'" active>
            <hr />
            <Gameclaimed :name="gameName"></Gameclaimed>
          </CTab>
          <CTab :title="gameName + ' unclaimed Points'">
            <hr />
            <Gameunclaimed :name="gameName"></Gameunclaimed>
          </CTab>
          <CTab :title="gameName + ' Points Entry'">
            <hr />
            <GamepointEntry :name="gameName"></GamepointEntry>
          </CTab>
          <CTab :title="gameName + ' Daily Limit'">
            <hr />
            <SnakeDailyLimit :name="gameName"></SnakeDailyLimit>
          </CTab>
        </CTabs>
      </CCol>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import Gameclaimed from "./gameclaimed.vue";
import Gameunclaimed from "./gameunclaimed.vue";
import GamepointEntry from "./gamepointEntry.vue";
import SnakeDailyLimit from "./snakeDailyLimit.vue";
export default {
  components: {
    Gameclaimed,
    Gameunclaimed,
    GamepointEntry,
    SnakeDailyLimit,
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
      gameName: "snake",
      gameList: [
        { id: 1, name: "snake" },
        { id: 2, name: "tower game" },
        { id: 3, name: "carrom" },
        { id: 4, name: "dunkmaster" },
      ],
    };
  },
  watch: {},
  methods: {
    // sendmsg(){}
  },
  created() {
    let self = this;
    // console.log(self.gameList, "gameList Before");
    db.collection("gamesList")
      .doc("1")
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          let gameListFromDB = snapshot.data().data;
          self.gameList = [];
          for (let i = 0; i < gameListFromDB.length; i++) {
            self.gameList.push({
              id: i,
              name: gameListFromDB[i],
            });
          }
          // console.log("gameList From Db", gameListFromDB);
          // console.log(self.gameList, "gameList");
        }
      });
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>